import React, { useState } from 'react';
import DownloadExcel from './downloadExcel/DownloadExcel';
import APopover from '../../../../common/a-popover';
import AButton from '../../../../common/form-fields-mui/AButton';
import { ReactComponent as ExcelIcon } from "assets/img/svg/excel.svg";
import DownloadLedgerReport from './downloadLedgerReport/DownloadLedgerReport';
import { useGetCollectPaymentContext } from '../../context';
import moment from 'moment';


const DownloadChargesData = () => {

    const {
        studentChargesListFiltered,
        studentBasicDetails,
    } = useGetCollectPaymentContext();

    const { psid, applicationId } = studentBasicDetails;
    const fileName = () => `${psid}_${applicationId}_${moment(new Date()).format('DD_MM_YY HH:mm')}`;

    const [ledgerReportDownloading, setLedgerReportDownloading] = useState(false);


    return (
        <APopover
            buttonComponent={(openPopup) =>
                <AButton
                    onClick={openPopup}
                    variant='outline'
                    outlineVariantColor='#CCC'
                    textColor='#0F0F0F'
                    size='xs'
                >
                    <ExcelIcon className='mr-1' />
                    Download
                </AButton>}

            menuComponent={() =>
                <div className='download-charges-data-card'>
                    <h3 className='mb-0'>Downloads</h3>

                    <DownloadExcel
                        fileName={fileName}
                        studentChargesListFiltered={studentChargesListFiltered}
                    />

                    <DownloadLedgerReport
                        fileName={fileName}
                        studentBasicDetails={studentBasicDetails}
                        downloading={ledgerReportDownloading}
                        setDownloading={setLedgerReportDownloading}
                    />
                </div>

            }
        />
    )

}

export default DownloadChargesData;